import { motion } from "framer-motion"
import Lottie from "lottie-react"
import { useNavigate } from "react-router-dom"
import fork from "../animations/fork.json"

import coverPhoto from "../assets/video.mp4"

export default function GettingStarted() {

    const navigate = useNavigate()

    return (
        <motion.div 
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.2 }}
            style={{
                backgroundColor: "#000",
                width: "100vw",
                height: "100vh",
                overflow: 'hidden'
            }}>

            <video 
            src={coverPhoto} 
            className="landing-img" 
            autoPlay={true}
            controls={false}
            loop
            muted
            />
            <div className="backdrop-gradient" />

            <div style={{
                position: "fixed",
                bottom: 10,
                width: "90vw",
                margin: "0 5vw",
                textAlign: "center"
            }}>
                <Lottie 
                    animationData={fork}
                    loop
                />

                <h1 style={{ fontSize: 35, color: "white" }}>Welcome to Rasking Grilled Chicken And Steak</h1>
                <p style={{ color: "grey" }}>
                    Looking forward to cook for you!!</p>
                <br/>
                <button onClick={() => navigate("/login")} style={{ backgroundColor: "var(--primary)" }} >Get Started</button>
            </div>
        
        </motion.div>
    )
}